/**
 * Renderer Typesense-snippet trygt: kun <mark>-tagger beholdes som highlight.
 */
export function SearchSnippet({ html }: { html: string }) {
  const parts = html.split(/(<mark>.*?<\/mark>)/gi);
  return (
    <p className="mt-1 line-clamp-2 text-[11px] leading-relaxed text-text-secondary">
      {parts.map((part, index) => {
        const match = part.match(/^<mark>(.*?)<\/mark>$/i);
        if (match) {
          return (
            <mark
              key={index}
              className="rounded-[2px] bg-accent/25 px-0.5 font-medium text-text-primary"
            >
              {match[1]}
            </mark>
          );
        }
        return <span key={index}>{part}</span>;
      })}
    </p>
  );
}
